import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

function CustomTooltip({ tooltipText, children, placement = 'bottom', tooltipClass = 'custom-tooltip' }) {
  if (!children) {
    return null;
  }

  if (Array.isArray(children)) {
    return <div>{children}</div>;
  }

  const childCount = React.Children.count(children);
  if (childCount > 1) {
    return <div>{children}</div>;
  }

  if (childCount === 0) {
    return null;
  }

  if (!React.isValidElement(children)) {
    return children;
  }

  if (children.type === React.Fragment) {
    return <div>{children}</div>;
  }

  try {
    return (
      <OverlayTrigger
        trigger={['hover', 'focus']}
        placement={placement}
        flip
        popperConfig={{ modifiers: [{ name: 'preventOverflow', options: { padding: 8 } }] }}
        overlay={<Tooltip className={tooltipClass}>{tooltipText}</Tooltip>}
      >
        {children}
      </OverlayTrigger>
    );
  } catch (error) {
    return children;
  }
}

export default CustomTooltip;
